import * as CryptoJS from 'crypto-js';

/**
 * Сервис шифрования строк.
 * Работает аналогично шифрованию строк в апи вебадмина.
 */
export class StringEncryptionService
{
	private static readonly iv = CryptoJS.lib.WordArray.create(new Uint8Array(16));
	private static readonly defaultKey = 'b14ca5898a4e4142aace2ea2143a2410';

	public static encryptString(plainText: string, key: string = this.defaultKey) : string {
		const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Utf8.parse(key), {

			iv: this.iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,

		});

		return encrypted.toString();
	}

	public static decryptString(cipherText: string, key: string = this.defaultKey): string {
		const decrypted = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse(key), {
			iv: this.iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		return decrypted.toString(CryptoJS.enc.Utf8);
	}
}